import Axios from 'axios';
import sha256 from 'crypto-js/sha256';
import sha1 from 'crypto-js/sha1';
import { useSelector } from 'react-redux';
import { select,call, put, takeEvery } from 'redux-saga/effects';
import { POST_SIGNUP, POST_SGINUP_SUCCESS } from '../redux/ducks/signup';
import {parseStdResponseError, SignUpUser} from '../server/WebServiceUrl';
import {SIGNIN_SUCCESS,initialState } from '../redux/ducks/userDuck'
import { READ_MERCHANT_SUCCESS } from '../redux/ducks/merchant';
import Cookies from 'js-cookie';

export const getSignupData = (state) => state.signup

async function axiosSignUp(signUpData){
  let result = {
    data:{}
  };
  try{
    result = await Axios.put(SignUpUser,signUpData);     
  }catch(e){
    if(e.response){
      result.data = e.response.data;
    }    
  }
  return result.data;
}


function* asyncPostSignup(signUpActionParam) {  
  const callback = signUpActionParam.payload.callback || (()=>({})); 
  const formData = signUpActionParam.payload.data;
  let rawPw = formData.password;
  formData.password = sha256(rawPw).toString();
  formData.sha1 = sha1(rawPw).toString();
  
  let app = yield select( state => state.app);
  
  let myForm = {};
  Object.assign(myForm,formData); 
  myForm.lang = app.lang;
  const data = yield call(
    axiosSignUp,myForm
  );
  

  let pass = false;
  let errorMsg = '';
  let userPayload = initialState
  let merchantPayload = {};
  let locator = [];
  if(data.classKey){
    if(data.classKey === 'KppResponse'){
      pass = data.pass;
      if(!pass && data.error){        
        let dataError = data.error;
        if(dataError.messCode){
          errorMsg = "KppResponse." + dataError.messCode;
        }
      }else{
        let result = data.info  
        if(window.MA) {
          window.MA.events("general", "register", "email", formData.email, {register: new Date()});
        }      
        //Cookies.set('authorization', result.authorization)     
        //userPayload.email =  result.user.email
        //userPayload.type = result.user.type
        //userPayload.authorization = result.authorization
  
        // if(result.merchant){
        //   merchantPayload = result.merchant;
        // }

      }

      parseStdResponseError(data,locator);



    }
  }





  if(callback){    
    callback({
      pass:pass,error:errorMsg,locator:locator
    })
  }
  
  yield put({ type: POST_SGINUP_SUCCESS, payload: {
    pass:pass,error:errorMsg
  }  });

 // yield put({ type: SIGNIN_SUCCESS, payload: userPayload  });
  //yield put({type: READ_MERCHANT_SUCCESS, payload: merchantPayload});
}

function* mySaga() {
  yield takeEvery(POST_SIGNUP, asyncPostSignup);
}

export default mySaga;